// @ts-nocheck
import React from "react";
import DeviceMenu from "../Shared/DeviceMenu";
import { useDevice } from "../../../Api/newSockets.api";
import DevicesHeader from "../../../components/Header/DevicesHeader";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import { savePathToLocalStorage } from "../../../utils/helpers";
import ChatInterface from "./ChatInterface";

type Props = {
  match: any;
};

const DeviceChat = (props: Props) => {
  savePathToLocalStorage();

  const deviceId = props.match.params.deviceId;
  const { getDevice } = useDevice();
  const { device } = getDevice(parseInt(deviceId));

  return device ? (
    <div className="device-main main-content" style={{ overflowX: "hidden", minWidth: 0 }}>
      <DevicesHeader device={device} />
      <div className="general-body-content">
        <div>
          <DeviceMenu typeId={device.deviceTypes.id} />
        </div>
        <div style={{ flex: 1, minWidth: 0, padding: "0 16px" }}>
          <ChatInterface deviceId={Number.parseInt(deviceId, 10)} deviceName={device.name} />
        </div>
      </div>
    </div>
  ) : (
    <LoadingSpinner />
  );
};

export default DeviceChat;
